import React, { ReactElement } from "react";
import { Table } from "antd";
import { rowClassName } from "..";
import { XtdByGroupRecord } from "../../../redux/types/reportTypes";
import "./index.scss";

export const columns = [
  {
    title: "Cluster",
    dataIndex: "cluster",
  },
  {
    title: "MANAGER",
    dataIndex: "manager",
  },
  {
    title: "ORIGAMI",
    dataIndex: "origami",
  },
  {
    title: "LWTD",
    dataIndex: "lwtd",
  },
  {
    title: "WTD",
    dataIndex: "wtd",
  },
  {
    title: "WTD DIFF",
    dataIndex: "wtd_diff",
  },
  {
    title: "WTD % DIFF",
    dataIndex: "wtd_perc_diff",
  },
  {
    title: "LMTD",
    dataIndex: "lmtd",
  },
  {
    title: "MTD",
    dataIndex: "mtd",
  },
  {
    title: "MTD DIFF",
    dataIndex: "mtd_diff",
  },
  {
    title: "MTD % DIFF",
    dataIndex: "mtd_perc_diff",
  },
  {
    title: "LQTD",
    dataIndex: "lqtd",
  },
  {
    title: "QTD",
    dataIndex: "qtd",
  },
  {
    title: "QTD DIFF",
    dataIndex: "qtd_diff",
  },
  {
    title: "QTD % DIFF",
    dataIndex: "qtd_perc_diff",
  },
];

type GroupTableProps = {
  loading: boolean;
  records: Array<XtdByGroupRecord>;
};

type Keys =
  | "lwtd"
  | "wtd"
  | "wtd_diff"
  | "wtd_perc_diff"
  | "lmtd"
  | "mtd"
  | "mtd_diff"
  | "mtd_perc_diff"
  | "lqtd"
  | "qtd"
  | "qtd_diff"
  | "qtd_perc_diff";

const GroupTable = ({ loading, records }: GroupTableProps): ReactElement => {
  const sum = (key: Keys) =>
    records.reduce((a, b) => a + (parseFloat(String(b[key])) || 0), 0);

  const calculateResultRow = () => {
    const result: XtdByGroupRecord = {
      cluster: "",
      manager: "",
      origami: "",
      lwtd: 0,
      wtd: 0,
      wtd_diff: 0,
      wtd_perc_diff: 0,
      lmtd: 0,
      mtd: 0,
      mtd_diff: 0,
      mtd_perc_diff: 0,
      lqtd: 0,
      qtd: 0,
      qtd_diff: 0,
      qtd_perc_diff: 0,
    };

    Object.keys(records[0]).forEach((key) => {
      if (key !== "cluster" && key !== "manager" && key !== "origami") {
        const newKey = key as Keys;
        result[newKey] = sum(newKey);
      }
    });

    return result;
  };

  const totalRecords = () => {
    const newRecords = [...records];
    if (newRecords.length) newRecords.push(calculateResultRow());
    return newRecords;
  };

  return (
    <Table
      className="group-table"
      dataSource={totalRecords()}
      columns={columns}
      loading={loading}
      rowKey="cluster"
      pagination={false}
      scroll={{ y: 250 }}
      size="small"
      rowClassName={rowClassName}
    />
  );
};

export default GroupTable;
